import React, { FC, Suspense, lazy } from "react";
import { Box, Dialog, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../Loading";
import Impressum from "./Contents/Impressum";
import Disclaimer from "./Contents/Disclaimer";
import Datenschutz from "./Contents/Datenschutz";

const ContactForm = lazy(() => import("../Forms/Contact"));
const Nutzungsbedingungen = lazy(
  () => import("./Contents/Nutzungsbedingungen")
);

export type DialogContent =
  | "kontakt"
  | "nutzungsbedinungen"
  | "impressum"
  | "disclaimer"
  | "datenschutz";

const getDialogTitle = (key: DialogContent): string => {
  switch (key) {
    case "kontakt":
      return "Kontaktformular";
    case "nutzungsbedinungen":
      return "Nutzungsbedingungen";
    case "impressum":
      return "Impressum";
    case "disclaimer":
      return "Disclaimer";
    case "datenschutz":
      return "Datenschutzerklärung TRC";
  }
};

type LazylyLoadDialogContentsProps = {
  onFinish: () => void;
  open: boolean;
  dialogKey: DialogContent;
};

const LazylyLoadDialogContents: FC<LazylyLoadDialogContentsProps> = ({
  dialogKey,
  onFinish,
  open,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => onFinish()}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      PaperProps={{ sx: { p: 2 } }}
    >
      <DialogTitle sx={{ p: 0, fontWeight: "bold", height: "50px" }}>
        {getDialogTitle(dialogKey)}
        <IconButton
          aria-label="close"
          onClick={() => onFinish()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "calc(100% - 50px)",
          overflowY: "auto",
        }}
      >
        <Suspense fallback={<Loading />}>
          {dialogKey === "kontakt" && <ContactForm onFinish={onFinish} />}
          {dialogKey === "nutzungsbedinungen" && <Nutzungsbedingungen />}
          {dialogKey === "impressum" && <Impressum />}
          {dialogKey === "disclaimer" && <Disclaimer />}
          {dialogKey === "datenschutz" && <Datenschutz />}
        </Suspense>
      </Box>
    </Dialog>
  );
};

export default LazylyLoadDialogContents;
